<template>
  <b-modal
    :no-close-on-backdrop="true"
    size="lg"
    :title="$t('item_add_new')"
    ref="innermodal"
  >
    <div class="row">
      <div class="col-sm-12">
        <div class="flex-container">
          <div>
            <div>
              <img
                :src="img"
                @click="$refs.file.click()"
                style="width: 120px; height: 120px"
              />
              <input
                type="file"
                ref="file"
                hidden
                accept="image/*"
                @change="fileChange"
              />
            </div>
          </div>
          <div class="flex-right">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="label-control blue">{{ $t("type") }}</label>
                  <div>
                    <select
                      class="form-control form-control-sm"
                      v-model="model.ProductTypeId"
                      @change="typeChange"
                    >
                      <option
                        v-for="ret in $productTypes()"
                        :key="ret.id"
                        :value="ret.id"
                      >
                        {{ $t(ret.lang) }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="label-control blue">Code/Number</label>
                  <div>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="model.Num"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div
                  class="form-group"
                  :class="{ 'form-group-error': $v.model.Name.$error }"
                >
                  <label class="label-control blue"
                    >{{ $t("item_name") }}
                    <span class="text-danger">*</span>
                  </label>
                  <div>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="$v.model.Name.$model"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label class="label-control blue">Sale Description</label>
          <div>
            <textarea
              class="form-control form-control-sm"
              v-model="model.SaleDesc"
            ></textarea>
          </div>
        </div>
      </div>
      <div v-if="model.ProductTypeId != 3" class="col-sm-12">
        <div class="form-group">
          <label class="label-control blue">Purchase Description</label>
          <div>
            <textarea
              class="form-control form-control-sm"
              v-model="model.PurchDesc"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="label-control blue">{{ $t("price_sale") }}</label>
          <div>
            <input
              class="form-control form-control-sm"
              type="number"
              v-model="model.Price"
            />
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label class="label-control blue">{{ $t("sale_tax") }}</label>
          <div>
            <select class="form-control form-control-sm" v-model="model.IncludeTax">
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div
          class="form-group"
          :class="{ 'form-group-error': $v.model.StockAccountId.$error }"
        >
          <label class="label-control blue">Asset Account</label>
          <div>
            <CoaSelect
              :v-store="isStore"
              :value="model.StockAccountName"
              @select="coaSelect(3, $event)"
              :v-disabled="model.ProductTypeId == 3"
            ></CoaSelect>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div
          class="form-group"
          :class="{ 'form-group-error': $v.model.IncomeAccountId.$error }"
        >
          <label class="label-control blue">Revenue Account</label>
          <div>
            <CoaSelect
              :v-store="isStore"
              :value="model.IncomeAccountName"
              @select="coaSelect(1, $event)"
            ></CoaSelect>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div
          class="form-group"
          :class="{ 'form-group-error': $v.model.ExpenseAccountId.$error }"
        >
          <label class="label-control blue">Cost Account</label>
          <div>
            <CoaSelect
              :v-store="isStore"
              :value="model.ExpenseAccountName"
              @select="coaSelect(2, $event)"
              :v-disabled="model.ProductTypeId == 3"
            ></CoaSelect>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-btn variant="primary" size="sm" @click="clickSaveHandler"
        ><i class="fa fa-floppy-o" aria-hidden="true"></i> {{ $t("save") }}</b-btn
      >
    </template>
  </b-modal>
</template>
<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import CoaSelect from "../Accountings/CoaSelect";
export default {
  components: { CoaSelect },
  data() {
    return {
      model: {
        Num: "",
        Name: "",
        NameEn: "",
        Description: "",
        ProductTypeId: 1,
        CategoryId: "",
        CanSold: true,
        CanPurchase: true,
        Image: "",
        BeginCost: 0,
        Price: 0,
        AlertQty: 0,
        BeginQty: 0,
        UomId: "",
        BrandId: "",
        IncludeTax: 1,
        StockAccountId: "",
        StockAccountName: "",
        ExpenseAccountId: "",
        ExpenseAccountName: "",
        IncomeAccountId: "",
        IncomeAccountName: "",
        Weight: "",
        IsMultipleUnit: true,
      },
      categories: [],
      units: [],
      brands: [],
      img: "/img/no-image.svg",
      actionLink: "item/save",
      formHead: {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
      isStore: true,
      line_no: this.vLineNo,
    };
  },
  validations: {
    model: {
      Name: { required },
      ProductTypeId: { required },
      StockAccountId: { required: requiredIf((vm) => vm.ProductTypeId != 3) },
      ExpenseAccountId: { required: requiredIf((vm) => vm.ProductTypeId != 3) },
      IncomeAccountId: { required },
    },
  },
  created: function () {
    this.initialize().then(() => {
      let id = this.$route.params.id;
      if (id != undefined) {
        let loading = this.$loading.show();
        this.actionLink = "item/update";
        this.$api()
          .post("item/find", { Id: id })
          .then((res) => {
            if (this.$isValid(res)) {
              this.model = res.data.Data;
              if (this.model.Image != null) {
                this.img = this.$base() + "image/items/" + this.model.Image;
              }
              this.filterAccountName();
            }
          })
          .finally(function () {
            loading.hide();
          });
      } else {
        this.filterAccount();
      }
    });
  },
  methods: {
    async clickSaveHandler() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var loading = this.$loading.show();
        try {
          var formData = new FormData();
          formData.append("File", this.$refs.file.files[0]);
          if (this.actionLink == "item/update") {
            formData.append("Id", this.model.Id);
          }
          for (var p in this.model) {
            if (this.model[p] != null) formData.append(p, this.model[p]);
          }
          formData.append("CompanyId", this.$store.state.company.Id);
          formData.append("ClientId", this.$store.state.company.ClientId);
          var res = await this.$api().post(this.actionLink, formData, this.formHead);
          if (this.$isValid(res)) {
            let item = res.data.Json.Item;
            this.$emit("done", item);
            this.$refs.innermodal.hide();
            this.model.Num = "";
            this.model.Name = "";
            this.model.NameEn = "";
            this.model.Description = "";
            this.model.ProductTypeId = 1;
            this.model.CategoryId = "";
            this.model.CanSold = true;
            this.model.CanPurchase = true;
            this.model.Image = "";
            this.model.BeginCost = 0;
            this.model.Price = 0;
            this.model.AlertQty = 0;
            this.model.BeginQty = 0;
            this.model.UomId = "";
            this.model.BrandId = "";
            this.model.IncludeTax = 1;
            this.model.StockAccountId = "";
            this.model.ExpenseAccountId = "";
            this.model.ExpenseAccountName = "";
            this.model.IncomeAccountId = "";
            this.model.IncomeAccountName = "";
            this.model.Weight = "";
            this.model.IsMultipleUnit = true;
            this.model.SaleDesc = "";
            this.model.PurchDesc = "";
            this.$v.$reset();
          }
        } catch (ex) {
          this.$swal.fire("Waring message", ex.message, "warning");
        } finally {
          loading.hide();
        }
      }
    },
    fileChange(e) {
      this.img = URL.createObjectURL(e.target.files[0]);
    },
    initialize() {
      return new Promise((resolve) => {
        let loading = this.$loading.show();
        this.$api()
          .post("item/initialize", { CompanyId: this.$store.state.company.Id })
          .then((res) => {
            if (this.$isValid(res)) {
              var json = res.data.Json;
              this.$store.state.accounts = json.Accounts;
              this.categories = json.Categories;
              this.units = json.Uoms;
              this.brands = json.Brands;
              resolve();
            }
          })
          .finally(function () {
            loading.hide();
          });
      });
    },
    typeChange() {
      if (this.model.ProductTypeId == 3) {
        this.model.CategoryId = "";
        this.model.UomId = "";
        this.model.Weight = "";
        this.model.IsMultipleUnit = false;
        this.model.StockAccountId = "";
        this.model.StockAccountName = "";
        this.model.ExpenseAccountId = "";
        this.model.ExpenseAccountName = "";
      } else {
        this.filterAccount();
      }
    },
    coaSelect(n, sender) {
      if (n == 1) {
        this.model.IncomeAccountId = sender.Id;
        this.model.IncomeAccountName = sender.Name;
      } else if (n == 2) {
        this.model.ExpenseAccountId = sender.Id;
        this.model.ExpenseAccountName = sender.Name;
      } else if (n == 3) {
        this.model.StockAccountId = sender.Id;
        this.model.StockAccountName = sender.Name;
      }
    },
    filterAccount: function () {
      let accounts = this.$store.state.accounts;
      let isSale = false;
      let isAsset = false;
      let isExpense = false;
      for (var i = 0; i < accounts.length; i++) {
        let item = accounts[i];
        if (item.Name == "Sale") {
          this.model.IncomeAccountId = item.Id;
          this.model.IncomeAccountName = item.Name;
          isSale = true;
        } else if (item.Name == "Cost of Goods Sold") {
          this.model.ExpenseAccountId = item.Id;
          this.model.ExpenseAccountName = item.Name;
          isExpense = true;
        } else if (item.Name == "Inventory Asset") {
          this.model.StockAccountId = item.Id;
          this.model.StockAccountName = item.Name;
          isAsset = true;
        }
        if (isSale && isAsset && isExpense) {
          break;
        }
      }
    },
    filterAccountName: function () {
      let accounts = this.$store.state.accounts;
      let isSale = false;
      let isAsset = false;
      let isExpense = false;
      for (var i = 0; i < accounts.length; i++) {
        let item = accounts[i];
        if (item.Id == this.model.IncomeAccountId) {
          this.model.IncomeAccountName = item.Name;
          isSale = true;
        } else if (item.Id == this.model.ExpenseAccountId) {
          this.model.ExpenseAccountName = item.Name;
          isExpense = true;
        } else if (item.Id == this.model.StockAccountId) {
          this.model.StockAccountName = item.Name;
          isAsset = true;
        }
        if (isSale && isAsset && isExpense) {
          break;
        }
      }
    },
  },
};
</script>
<style scoped>
.item-img-element {
  display: flex;
}
.item-img-element .card-img-top {
  width: 105px;
  height: 105px;
  overflow: hidden;
  border-radius: 3px;
  border: 1px solid #ddd;
}
.item-img-element img {
  width: 105px;
  height: 105px;
}
.item-img-element .side-right {
  width: 100%;
  padding-left: 10px;
}
</style>
